export default __webpack_public_path__ + "static/media/cabello-corto-hombre-rubio.8b6783f4.png";